import React from 'react'
import createReactClass from 'create-react-class'
import PriceFormatter from '../../utils/price-formatter'
import { clsx } from "clsx";

var Price = createReactClass({
	render: function() {
        const {
            price,
            discountedPrice,
            discount,
            twoLines = false,
            normal = false,
            small = false,
            showAsterisk = false,
            className,
          } = this.props;

        const priceClass = "price" + (discountedPrice && discount > 0 ? " discounted" : "");

		return (
            <div
              className={clsx(["priceContainer", className], {
                ["twoLinesPrice"]: twoLines,
                ["normalPrice"]: normal,
                ["smallPrice"]: small,
              })}
            >
                <div className={priceClass}>{PriceFormatter(discountedPrice ? discountedPrice : price)}</div>
            </div>
          );
	}
});

export default Price;